import React, { useState } from 'react';
import { PictureInPictureAlt, WidthFull, WidthWide } from '@mui/icons-material';
import { AIAssistantPositionType } from 'src/features/AIAssistantPosition';
import AIAssistantSideView from './components/SideView';
import AIAssistantNoneSideView from './components/NoneSideView';
import { useChatV2 } from 'src/hooks/useChatV2';
import { pipPositionMargin, pipSize } from 'src/features/chatNow';

interface ChatComponentProps {
  mode: 'normal' | 'pip';
  isVisible?: boolean;
  customWidthPercentage?: string;
}

interface IPositionModeOptions {
  value: AIAssistantPositionType;
  label: string;
  icon: React.ReactNode;
}

export const positionMode: IPositionModeOptions[] = [
  {
    value: 'side',
    label: 'Side',
    icon: <WidthWide />
  },
  {
    value: 'full',
    label: 'Full Width',
    icon: <WidthFull />
  },
  {
    value: 'window',
    label: 'Window',
    icon: <PictureInPictureAlt />
  }
];

export const TOP_LEFT = { x: 0 + pipPositionMargin, y: 0 + pipPositionMargin };
export const TOP_RIGHT = {
  x: window.innerWidth - (pipSize.width + pipPositionMargin),
  y: 0 + pipPositionMargin
};
export const BOTTOM_LEFT = {
  x: 0 + pipPositionMargin,
  y: window.innerHeight - (500 + pipPositionMargin)
};
export const BOTTOM_RIGHT = {
  x: window.innerWidth - (pipSize.width + pipPositionMargin),
  y: window.innerHeight - (500 + pipPositionMargin) - 40
};

const ChatNowRetail: React.FC<ChatComponentProps> = ({
  mode,
  isVisible = true,
  customWidthPercentage = '100%'
}) => {
  const {
    handleChangePositionMode,
    handleSendMessage,
    sendingLoading,
    handleCloseAIAssistant,
    handleClickTopic,
    handleSendBooleanQueryMessage,
    handleSendChatNowMessage,
    chatInputValue,
    isLoading,
    handleChange,
    handleClickNewChat
  } = useChatV2();

  // PiP specific state
  const [isMinimized, setIsMinimized] = useState<boolean>(false);

  const handleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  if (mode === 'pip') {
    if (!isVisible) return null;

    return (
      <AIAssistantNoneSideView
        isVisible={isVisible}
        chatInputValue={chatInputValue}
        handleChange={handleChange}
        handleChangePositionMode={handleChangePositionMode}
        handleClickTopic={handleClickTopic}
        handleCloseAIAssistant={handleCloseAIAssistant}
        handleSendBooleanQueryMessage={handleSendBooleanQueryMessage}
        handleSendChatNowMessage={handleSendChatNowMessage}
        handleSendMessage={handleSendMessage}
        isLoading={isLoading}
        sendingLoading={sendingLoading}
        handleMinimize={handleMinimize}
        isMinimized={isMinimized}
        handleClickNewChat={handleClickNewChat}
      />
    );
  }

  // Normal mode
  return (
    <AIAssistantSideView
      customWidthPercentage={customWidthPercentage}
      chatInputValue={chatInputValue}
      handleChange={handleChange}
      handleChangePositionMode={handleChangePositionMode}
      handleClickTopic={handleClickTopic}
      handleCloseAIAssistant={handleCloseAIAssistant}
      handleSendBooleanQueryMessage={handleSendBooleanQueryMessage}
      handleSendChatNowMessage={handleSendChatNowMessage}
      handleSendMessage={handleSendMessage}
      isLoading={isLoading}
      sendingLoading={sendingLoading}
      handleClickNewChat={handleClickNewChat}
    />
  );
};

export default ChatNowRetail;
